import { Button, Modal } from 'antd';
import { useState, useRef, useEffect } from 'react';
import { BarcodeFormat, BrowserBarcodeReader } from '@zxing/library';
import { ImageTheme } from '../../../components/images';
import exBarcode from '../../../assets/images/ex_take_barcode_photo.jpg';
import { color } from '../../../resources';
import { TextSmall } from '../../../components/text';
import React from 'react';
import { cardStyle } from '../styles/styles';
export const BarcodeScannerModal = ({ open, onClose, onDetected }) => {
  const [scanResult, setScanResult] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setScanResult('');
    }
  }, [open]);

  const handleOpenFilePicker = () => {
    fileInputRef.current?.click();
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = async () => {
        const codeReader = new BrowserBarcodeReader();
        try {
          const result = await codeReader.decodeFromImageElement(img, {
            tryHarder: true,
          });

          if (result.format === BarcodeFormat.EAN_13) {
            setScanResult(result.text);
            onDetected(result.text);
            onClose();
          }
        } catch (error) {
          alert('ไม่สามารถอ่านบาร์โค้ดจากภาพนี้ได้ กรุณาลองใหม่อีกครั้ง');
        }
      };
    };
    reader.readAsDataURL(file);
  };
  return (
    <Modal title="สแกนบาร์โค้ด" open={open} onCancel={onClose} footer={null}>
      <div style={cardStyle}>
        <TextSmall
          text={<span>ตั้งกล้องมือถือในแนวตั้ง เพื่อถ่าย Barcode</span>}
          style={{ color: '#8c6e19' }}
          bold
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 10 }}>
        <ImageTheme
          src={exBarcode}
          style={{
            width: '100%',
            maxWidth: 400,
            borderRadius: '5px',
            display: 'block',
            margin: 'auto',
          }}
        />
      </div>
      <input
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleImageUpload}
      />

      <Button
        type="primary"
        onClick={handleOpenFilePicker}
        style={{ width: '100%', background: color.redRizz }}
      >
        เลือกหรือถ่ายภาพบาร์โค้ด
      </Button>
      {scanResult && (
        <p style={{ textAlign: 'center', marginTop: 20 }}>
          บาร์โค้ดที่พบ: <strong>{scanResult}</strong>
        </p>
      )}
    </Modal>
  );
};
